import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=f8948fde&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"
import style0 from "./Record.vue?vue&type=style&index=0&id=f8948fde&prod&scoped=true&lang=css"
import style1 from "./Record.vue?vue&type=style&index=1&id=f8948fde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8948fde",
  null
  
)

export default component.exports